export enum DropdownEntityType {
    ALLCLIENT,
    CLIENT,
}